import { ChatComplianceBoxProps } from './chat-compliance-box';

export const chatComplianceBoxPropsSumma: ChatComplianceBoxProps = {
  headerText: 'Retningslinjer for anvendelse af Summa',
  mainText: `Summa skal anvendes af sagsbehandleren til at få et overblik over borgerens forløb på baggrund af sagens faktiske oplysninger, fx som forberedelse
    til afholdelse af samtaler med borgeren.

Summa må ikke anvendes til udarbejdelse af forvaltningsretlige afgørelser, til anbefaling eller udførelse af sagsskridt eller bruges til at foretage vurderinger.

For uddybende information vedrørende dette, se vores politik på området på Kundeweb:`,
  link: {
    href: 'https://kundeweb.schultz.dk/h/b023bd8d-e89a-4018-a525-55a8aad79278/fedee4a0824544429c65e8e9f7157292',
    label: 'Link til politik',
  },
};
